export const STATIC_ISSUE_SUMMARY_DATA_KEY = 'static-issue-summary-data';
